import React, { useState } from 'react';
import Rating from '@mui/material/Rating';
import TextField from '@mui/material/TextField';
import Input from '@mui/material/Input';
import Button from '@mui/material/Button';
import styles from '../Styles/WriteReviews.module.css';
import { addReview } from '../services/api.js';
import { message } from 'antd';

const WriteReviews = () => {

  const [formData, setFormData] = useState({
    name: '',
    destinations: [],
    destinationInput: '',
    rating: 0,
    experience: '',
  });

  const handleInputChange = (field) => (event) => {

    setFormData({
      ...formData,
      [field]: event.target.value,
    });
  };

  const handleRatingChange = (_, newValue) => {

    setFormData({
      ...formData,
      rating: newValue,
    });
  };

  const handleAddDestination = () => {

    const trimmed =
      formData.destinationInput.trim().toLowerCase();

    if (!trimmed) return;

    if (formData.destinations.includes(trimmed)) {

      message.warning('Destination already added');

      return;
    }

    setFormData({
      ...formData,
      destinations: [
        ...formData.destinations,
        trimmed,
      ],
      destinationInput: '',
    });
  };

  const handleRemoveDestination = (destinationToRemove) => {

    setFormData({
      ...formData,
      destinations: formData.destinations.filter(
        destination => destination !== destinationToRemove
      ),
    });
  };

  const handleSubmit = async () => {

    if (!formData.name.trim()) {

      message.warning('Please enter your name');

      return;
    }

    if (formData.destinations.length === 0) {

      message.warning('Please add at least one destination');

      return;
    }

    if (formData.rating === 0) {

      message.warning('Please provide a rating');

      return;
    }

    try {

      const payload = {
        client_name: formData.name.trim().toLowerCase(),
        destination: formData.destinations,
        rating: formData.rating,
        experience: formData.experience,
      };

      const result = await addReview(payload);

      if (result.success) {

        message.success('Thank you for your review!');

        setFormData({
          name: '',
          destinations: [],
          destinationInput: '',
          rating: 0,
          experience: '',
        });
      }

    }
    catch (error) {

      message.error('Error submitting review. Please try again later.');

      console.error(error);
    }
  };

  return (

    <div className={styles.container}>

      <div className={styles.logoAndNote}>

        <img
          src="/static/logo4.png"
          alt="Shivira Logo"
          className={styles.logo}
        />

        <p>
          We value your feedback! Please share your experience with us.
        </p>

      </div>

      <div className={styles.reviewForm}>

        <div className={styles.inputGroup}>

          <p style={{ position: 'relative', top: '0.5rem' }}>
            Your Name:
          </p>

          <Input
            required
            value={formData.name}
            onChange={handleInputChange('name')}
            sx={{
              '&:before': {
                borderBottom: '1px solid black',
              },
              '&:hover:not(.Mui-disabled):before': {
                borderBottom: '2px solid black',
              },
              '&:after': {
                borderBottom: '2px solid black',
              },
            }}
          />

        </div>

        <div className={styles.inputGroup}>

          <p style={{ position: 'relative', top: '0.1rem' }}>
            Your Rating:
          </p>

          <Rating
            name="review-rating"
            value={formData.rating}
            onChange={handleRatingChange}
          />

        </div>

        <div className={`${styles.inputGroup} ${styles.fullWidth}`}>

          <p style={{ minWidth: 'max-content' }}>
            Destinations:
          </p>

          <div className={styles.destinationWrapper}>

            <div className={styles.destinationInputRow}>

              <Input
                required
                value={formData.destinationInput}
                onChange={handleInputChange('destinationInput')}
                placeholder="Enter destination"
                sx={{
                  '&:before': {
                    borderBottom: '1px solid black',
                  },
                  '&:hover:not(.Mui-disabled):before': {
                    borderBottom: '2px solid black',
                  },
                  '&:after': {
                    borderBottom: '2px solid black',
                  },
                }}
              />

              <Button
                variant="contained"
                onClick={handleAddDestination}
                sx={{
                  backgroundColor: '#000000',
                  minWidth: 'max-content',
                }}
              >
                Add
              </Button>

            </div>

            <div className={styles.destinationTags}>

              {formData.destinations.map((destination) => (

                <div
                  key={destination}
                  className={styles.destinationTag}
                >

                  {destination}

                  <span
                    onClick={() =>
                      handleRemoveDestination(destination)
                    }
                  >
                    ✕
                  </span>

                </div>

              ))}

            </div>

          </div>

        </div>

        <div className={`${styles.inputGroup} ${styles.fullWidth}`}>

          <p style={{ minWidth: 'max-content' }}>
            Tell us about your experience:
          </p>

          <TextField
            fullWidth
            multiline
            minRows={5}
            maxRows={12}
            variant="filled"
            value={formData.experience}
            onChange={handleInputChange('experience')}
            sx={{
              '& .MuiFilledInput-root': {

                backgroundColor: 'grey.100',

                '&:before': {
                  borderBottom: '1px solid black',
                },

                '&:hover:not(.Mui-disabled):before': {
                  borderBottom: '2px solid black',
                },

                '&:after': {
                  borderBottom: '2px solid black',
                  borderBottomColor: 'black',
                },
              },
            }}
          />

        </div>

        <div className={styles.buttonContainer}>

          <Button
            variant="contained"
            onClick={handleSubmit}
            sx={{
              backgroundColor: '#000000',
            }}
          >
            Submit Review
          </Button>

        </div>

      </div>

      <div className={styles.footer}></div>

    </div>
  );
};

export default WriteReviews;